import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  tableStyle: { border: "none", boxShadow: "none" },
  tableText: {
    fontFamily: "Open Sans", fontWeight: 'normal', fontSize: "12px",
    lineHeight: "16px", color: "#141414", textAlign: "center",
    margin: "10px", padding: "6px", minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center", fontFamily: "Open Sans", fontStyle: "normal",
    fontWeight: "normal", color: '#6F6F6F', fontSize: "14px",
    lineHeight: "19px", padding: "6px",
  },
  even: { background: "#F3F3F3" },
  odd: { background: "#FFFFFF" },
}));

function BACENTable(props) {
  const classes = useStyles();
  let counter = 0;

  const getClass = (rowIndex) => {
    counter = counter + 1;
    if (rowIndex % 2 === 0) {
      return classes.even;
    }
    return classes.odd;
  };

  const monitoring_topic_data = props.bacen_data;

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Nome</TableCell>
            <TableCell className={classes.tableHeader}>Penalidade</TableCell>
            <TableCell className={classes.tableHeader}>Duração da Penalidade</TableCell>
            <TableCell className={classes.tableHeader}>Data de Publicação</TableCell>
            <TableCell className={classes.tableHeader}>Fim da Penalidade</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={getClass(counter)}>
            <TableCell className={classes.tableText}>{monitoring_topic_data?.name ?? "-"}</TableCell>
            <TableCell className={classes.tableText}>{monitoring_topic_data?.penalty ?? "-"}</TableCell>
            <TableCell className={classes.tableText}>{monitoring_topic_data?.penalty_duration ?? "-"}</TableCell>
            <TableCell className={classes.tableText}>{monitoring_topic_data?.publication_date ?? "-"}</TableCell>
            <TableCell className={classes.tableText}>{monitoring_topic_data?.penalty_end_date ?? "-"}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Paper>
  );
}

export default BACENTable;
